import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import * as mapbox from 'mapbox-gl';
import { environment } from 'src/environments/environment';

export interface GeoFenceJson {
  coordinates: [];
  type: string;
}

@Component({
  selector: 'app-mapbox-view',
  templateUrl: './mapbox-view.component.html',
  styleUrls: ['./mapbox-view.component.scss']
})
export class MapboxViewComponent implements OnInit,  AfterViewInit {
  map!: mapbox.Map;
  mapEdit!: mapbox.Map;
  mapCreateMap!: mapbox.Map;

  City = '';
  Type = '';
  Address = '';

  private geoFenceGeometry: any | null = null;

  @Input() permissionEdit = false;

  @Input() set _Address(value: any) {
    if (value !== undefined && value !== '') { this.Address = value; }
  }

  @Input() set _City(value: any) {
    if (value !== undefined && value !== '') { this.City = value; }
  }

  @Input() set _Type(value: any) {
    if (value !== undefined && value !== '') { this.Type = value; }
  }

  @Input() set _geoFenceJson(value: any) {
    this.geoFenceGeometry = this.normalizeGeometry(value);

    const removeAll = () => {
      if (this.Type === 'create' && this.mapCreateMap) {
        this.removeSourceAndLayer(this.mapCreateMap, 'mapCreate', 'mapCreate');
      } else {
        if (this.map) {this.removeSourceAndLayer(this.map, 'main', 'main'); }
        if (this.mapEdit) {this.removeSourceAndLayer(this.mapEdit, 'mainEdit', 'mainEdit'); }
      }
    };

    if (!this.geoFenceGeometry || this.isEmptyGeometry(this.geoFenceGeometry)) {
      removeAll();
      return;
    }

    if (this.Type === 'create' && this.mapCreateMap) {
      this.updateSourceAndFit(this.mapCreateMap, 'mapCreate', 'mapCreate', this.geoFenceGeometry);
    } else {
      if (this.map) {this.updateSourceAndFit(this.map, 'main', 'main', this.geoFenceGeometry); }
      if (this.mapEdit) { this.updateSourceAndFit(this.mapEdit, 'mainEdit', 'mainEdit', this.geoFenceGeometry); }
    }
  }

  @Output() clickOpcion1 = new EventEmitter();

  constructor() {}

  ngAfterViewInit(): void {
    if (this.Type === 'create') {
      this.mapCreate();
    } else {
      this.mapShow();
      this.mapEditShow();
    }
  }

  ngOnInit(): void {}

  clickOpc1() {
    this.clickOpcion1.emit();
  }

  private isEmptyGeometry(g: any): boolean {
    if (!g || !g.type || !Array.isArray(g.coordinates)) { return true; }

    if (g.type === 'Polygon') {
      if (g.coordinates.length === 0) { return true; }
      return g.coordinates.every((ring: any) => !Array.isArray(ring) || ring.length === 0);
    }

    if (g.type === 'MultiPolygon') {
      if (g.coordinates.length === 0) { return true; }
      return g.coordinates.every((poly: any) =>
        !Array.isArray(poly) || poly.length === 0 ||
        poly.every((ring: any) => !Array.isArray(ring) || ring.length === 0)
      );
    }
    return g.coordinates.length === 0;
  }

  private normalizeGeometry(input: any): any | null {
    if (!input) { return null; }
    try {
      const maybe = typeof input === 'string' ? JSON.parse(input) : input;
      if (maybe?.type && maybe?.coordinates) { return maybe; }
      if (maybe?.geometry?.type && maybe?.geometry?.coordinates) { return maybe.geometry; }
      return null;
    } catch {
      return null;
    }
  }

  private fitToGeometry(map: mapbox.Map, geometry: any, padding = 24) {
    if (!geometry?.coordinates || this.isEmptyGeometry(geometry)) { return; }

    const bounds = new mapboxgl.LngLatBounds();
    const walk = (coords: any) => {
      if (typeof coords?.[0] === 'number') { bounds.extend([coords[0], coords[1]]); return; }
      for (const c of coords) { walk(c); }
    };
    walk(geometry.coordinates);

    if (!bounds.isEmpty()) { map.fitBounds(bounds, { padding, maxZoom: 18, duration: 0 }); }
  }

  private removeSourceAndLayer(map: mapbox.Map, sourceId: string, layerId: string) {
    if (map.getLayer(layerId)) { map.removeLayer(layerId); }
    if (map.getLayer(`${layerId}-outline`)) { map.removeLayer(`${layerId}-outline`); }
    if (map.getSource(sourceId)) { map.removeSource(sourceId); }
  }

  private updateSourceAndFit(map: mapbox.Map, sourceId: string, layerId: string, geometry: any | null) {
    if (!geometry || this.isEmptyGeometry(geometry)) {
      this.removeSourceAndLayer(map, sourceId, layerId);
      return;
    }

    const feature = { type: 'Feature', geometry, properties: {} } as any;
    const src = map.getSource(sourceId) as mapboxgl.GeoJSONSource;

    if (src) {
      src.setData(feature);
    } else if (map.isStyleLoaded()) {
      map.addSource(sourceId, { type: 'geojson', data: feature });
      if (!map.getLayer(layerId)) {
        map.addLayer({
          id: layerId,
          type: 'fill',
          source: sourceId,
          paint: { 'fill-color': '#0080ff', 'fill-opacity': 0.5 }
        });
      }
      if (!map.getLayer(`${layerId}-outline`)) {
        map.addLayer({
          id: `${layerId}-outline`,
          type: 'line',
          source: sourceId,
          paint: { 'line-color': '#5c5c5c', 'line-width': 1 }
        });
      }
    }
    this.fitToGeometry(map, geometry, 32);
  }

  mapShow() {
    this.map = new mapboxgl.Map({
      accessToken: environment.api.MapboxAccessToken,
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v10',
      center: [-74.080833, 4.598889],
      zoom: 3
    });

    this.map.on('load', () => {
      setTimeout(() => this.map.resize(), 0);
      this.removeSourceAndLayer(this.map, 'main', 'main');

      if (!this.geoFenceGeometry || this.isEmptyGeometry(this.geoFenceGeometry)) { return; }

      this.map.addSource('main', {
        type: 'geojson',
        data: { type: 'Feature', geometry: this.geoFenceGeometry, properties: {} } as any
      });

      this.map.addLayer({
        id: 'main',
        type: 'fill',
        source: 'main',
        paint: { 'fill-color': '#0080ff', 'fill-opacity': 0.5 }
      });
      this.map.addLayer({
        id: 'main-outline',
        type: 'line',
        source: 'main',
        paint: { 'line-color': '#5c5c5c', 'line-width': 1 }
      });

      this.fitToGeometry(this.map, this.geoFenceGeometry, 32);
    });
  }

  mapEditShow() {
    this.mapEdit = new mapboxgl.Map({
      accessToken: environment.api.MapboxAccessToken,
      container: 'mapEdit',
      style: 'mapbox://styles/mapbox/streets-v10',
      center: [-74.080833, 4.598889],
      zoom: 3
    });

    this.mapEdit.on('load', () => {
      setTimeout(() => this.mapEdit.resize(), 0);
      this.removeSourceAndLayer(this.mapEdit, 'mainEdit', 'mainEdit');

      if (!this.geoFenceGeometry || this.isEmptyGeometry(this.geoFenceGeometry)) { return; }

      this.mapEdit.addSource('mainEdit', {
        type: 'geojson',
        data: { type: 'Feature', geometry: this.geoFenceGeometry, properties: {} } as any
      });

      this.mapEdit.addLayer({
        id: 'mainEdit',
        type: 'fill',
        source: 'mainEdit',
        paint: { 'fill-color': '#0080ff', 'fill-opacity': 0.5 }
      });
      this.mapEdit.addLayer({
        id: 'mainEdit-outline',
        type: 'line',
        source: 'mainEdit',
        paint: { 'line-color': '#5c5c5c', 'line-width': 1 }
      });

      this.fitToGeometry(this.mapEdit, this.geoFenceGeometry, 32);
    });
  }

  mapCreate() {
    this.mapCreateMap = new mapboxgl.Map({
      accessToken: environment.api.MapboxAccessToken,
      container: 'mapCreate',
      style: 'mapbox://styles/mapbox/streets-v10',
      center: [-74.1574237, 4.6455668],
      zoom: 3
    });

    this.mapCreateMap.on('load', () => {
      setTimeout(() => this.mapCreateMap.resize(), 0);
      this.removeSourceAndLayer(this.mapCreateMap, 'mapCreate', 'mapCreate');

      if (!this.geoFenceGeometry || this.isEmptyGeometry(this.geoFenceGeometry)) { return; }

      this.mapCreateMap.addSource('mapCreate', {
        type: 'geojson',
        data: { type: 'Feature', geometry: this.geoFenceGeometry, properties: {} } as any
      });

      this.mapCreateMap.addLayer({
        id: 'mapCreate',
        type: 'fill',
        source: 'mapCreate',
        paint: { 'fill-color': '#0080ff', 'fill-opacity': 0.5 }
      });
      this.mapCreateMap.addLayer({
        id: 'mapCreate-outline',
        type: 'line',
        source: 'mapCreate',
        paint: { 'line-color': '#5c5c5c', 'line-width': 1 }
      });

      this.fitToGeometry(this.mapCreateMap, this.geoFenceGeometry, 32);
    });
  }

}
